import { render, staticRenderFns } from "./keywordLibrary.vue?vue&type=template&id=bfaaeea2&scoped=true&"
import script from "./keywordLibrary.vue?vue&type=script&lang=ts&"
export * from "./keywordLibrary.vue?vue&type=script&lang=ts&"
import style0 from "./keywordLibrary.vue?vue&type=style&index=0&id=bfaaeea2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfaaeea2",
  null
  
)

export default component.exports